import { URI } from "../wallet.api";
import { _post } from "@api/doinsport/services/httpService";

const URI_OPERATION = URI + "/operations"

export const postWalletOperation = (operation) => _post(URI_OPERATION, operation);
